import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-106ecc92"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  id: "customers"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Factura No.", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Nombre del Prestador", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Código del Prestador", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Médico", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "NAF", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Autorización", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Fecha Autorización", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Nombre de la ARS", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Nombre del Paciente", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Afiliado o NSS", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Monto Reclamado", -1))
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "der" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_24 = { class: "der" }
const _hoisted_25 = {
  key: 1,
  class: "noRegist"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (this.totales.reclamos)
      ? (_openBlock(), _createElementBlock("table", _hoisted_1, [
          _hoisted_2,
          _hoisted_3,
          _hoisted_4,
          _hoisted_5,
          _hoisted_6,
          _hoisted_7,
          _hoisted_8,
          _hoisted_9,
          _hoisted_10,
          _hoisted_11,
          _hoisted_12,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.reclamos, (reclamo, index) => {
            return (_openBlock(), _createElementBlock("tr", {
              onClick: ($event: any) => (this.$router.push(`/reclamos/${reclamo._id}`)),
              key: index
            }, [
              _createElementVNode("td", null, _toDisplayString(reclamo.facNo), 1),
              _createElementVNode("td", null, _toDisplayString(reclamo.nombPres), 1),
              _createElementVNode("td", null, _toDisplayString(reclamo.codPres), 1),
              _createElementVNode("td", null, _toDisplayString(reclamo.med), 1),
              _createElementVNode("td", null, _toDisplayString(reclamo.naf), 1),
              _createElementVNode("td", null, _toDisplayString(reclamo.aut), 1),
              _createElementVNode("td", null, _toDisplayString($options.formatDate(reclamo.fechAutor, false)), 1),
              _createElementVNode("td", null, _toDisplayString(reclamo.nombARS), 1),
              _createElementVNode("td", null, _toDisplayString(reclamo.nombPac), 1),
              _createElementVNode("td", null, _toDisplayString(reclamo.aflNSS), 1),
              _createElementVNode("td", _hoisted_14, _toDisplayString($options.formatNumber(reclamo.montRec, true)), 1)
            ], 8, _hoisted_13))
          }), 128)),
          _createElementVNode("tr", null, [
            _createElementVNode("td", null, "Total: " + _toDisplayString($options.formatNumber(this.totales.reclamos, false)), 1),
            _hoisted_15,
            _hoisted_16,
            _hoisted_17,
            _hoisted_18,
            _hoisted_19,
            _hoisted_20,
            _hoisted_21,
            _hoisted_22,
            _hoisted_23,
            _createElementVNode("td", _hoisted_24, _toDisplayString($options.formatNumber(this.totales.valor, true)), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (!this.totales.reclamos)
      ? (_openBlock(), _createElementBlock("h6", _hoisted_25, " No se Encontraron Registros. "))
      : _createCommentVNode("", true)
  ], 64))
}